import O3Select from 'domovio-core/src/components/Form/Select/o3Select';
import InputError from 'domovio-core/src/components/Form/Input/InputError';

export default {
    components: {
        InputError,
        O3Select
    },
    data() {
        return {
            selected:     null,
            tempSelected: null,
        }
    },
    props:      {
        v:          {
            required: false,
        },
        lengthType: {
            type:     String,
            required: false,
            default:  () => null
        }
    },
    watch:      {
        selected: function (nextValue, prevValue) {
            this.emitId(nextValue, prevValue);
        },
        options:  function () {
            if (this.tempSelected) {
                this.setSelectedId(this.tempSelected);
            }
        }
    },
    methods:    {
        emitId: function (nextValue, prevValue) {
            if (nextValue !== prevValue) {
                if (null === nextValue) {
                    this.$emit('input', null);
                } else {
                    const { id } = nextValue;
                    this.$emit('input', id)
                }
            }
        },
        setSelectedId(selectedId) {
            this.tempSelected = selectedId;
            this.selected = this.options.find(({ id }) => id === selectedId) || null;
        }
    }
}
